/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-grid-pattern: [PENDING DOC]
 * @prop --sy-grid-gutter-size: [PENDING DOC]
 * @prop --sy-grid-alignment: [PENDING DOC]
 * @prop --sy-grid-count: [PENDING DOC]
 * @prop --sy-grid-offset: [PENDING DOC]
 * @prop --sy-grid-max-width-xs: Grid max width xs.
 * @prop --sy-grid-max-width-sm: Grid max width sm.
 * @prop --sy-grid-max-width-md: Grid max width md.
 * @prop --sy-grid-max-width-lg: Grid max width lg.
 * @prop --sy-grid-max-width-xl: Grid max width xl.
 * @prop --sy-grid-max-width-xxl: Grid max width xxl.
 * @prop --sy-grid-gap: Grid gap - It must be a single number value and defines both row and column gap
 * @prop --sy-grid-row-gap: Grid row gap.
 * @prop --sy-grid-column-gap: Grid column gap.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

:host([type=flex]) {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: var(--sy-grid-row-gap, var(--sy-grid-gap, var(--sy-spacer-5)));
  padding-right: calc(var(--sy-grid-column-gap, var(--sy-grid-gap, var(--sy-spacer-5))) * .5);
  padding-left: calc(var(--sy-grid-column-gap, var(--sy-grid-gap, var(--sy-spacer-5))) * .5);
}

:host([type=grid]) {
  display: grid;
  grid-auto-rows: 1fr;
  grid-auto-columns: 1fr;
  row-gap: var(--sy-grid-row-gap, var(--sy-grid-gap, var(--sy-spacer-5)));
  column-gap: var(--sy-grid-column-gap, var(--sy-grid-gap, var(--sy-spacer-5)));
}

@media (min-width: 0) {
  :host(:not([fluid])) {
    max-width: var(--sy-grid-max-width-xs, 100%);
  }
}
@media (min-width: 576px) {
  :host(:not([fluid])) {
    max-width: var(--sy-grid-max-width-sm, 540px);
  }
}
@media (min-width: 768px) {
  :host(:not([fluid])) {
    max-width: var(--sy-grid-max-width-md, 720px);
  }
}
@media (min-width: 992px) {
  :host(:not([fluid])) {
    max-width: var(--sy-grid-max-width-lg, 960px);
  }
}
@media (min-width: 1200px) {
  :host(:not([fluid])) {
    max-width: var(--sy-grid-max-width-xl, 1140px);
  }
}
@media (min-width: 1400px) {
  :host(:not([fluid])) {
    max-width: var(--sy-grid-max-width-xxl, 1320px);
  }
}